import React from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import { Typography, TypographyProps } from 'components/v2';

import { TypographyNodeName_Node$key } from './__generated__/TypographyNodeName_Node.graphql';

export interface TypographyNodeNameProps extends Omit<TypographyProps, 'classes'> {
  fragmentRef: TypographyNodeName_Node$key;
  me?: boolean;
}

const TypographyNodeName: React.FC<TypographyNodeNameProps> = ({ fragmentRef, me, ...rest }) => {
  const node = useFragment<TypographyNodeName_Node$key>(
    graphql`
      fragment TypographyNodeName_Node on Node {
        ... on Group {
          # Using alias bc of conflicting types String! and String.
          groupName: name
        }
        ... on Patient {
          name
        }
        ... on Provider {
          name
        }
        ... on User {
          name
        }
        ... on Facility {
          # Using alias bc of conflicting types String! and String.
          facilityName: name
        }
      }
    `,
    fragmentRef,
  );

  const name = me ? 'Me' : node.name || node.groupName || node.facilityName;

  return (
    <Typography variant="inherit" color="inherit" {...rest}>
      {name}
    </Typography>
  );
};

export default TypographyNodeName;
